import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  GetEffectiveSettingInput,
  GetEffectiveSettingVariables,
  GetEffectiveSettingQueryResponse,
} from '../types';

const getEffectiveSettingQuery = gql`
  query GetEffectiveSetting($input: GetEffectiveSettingInput!) {
    payrollGetEffectiveSetting(input: $input) {
      code
      success
      message
      data
    }
  }
`;

export const getEffectiveSetting = (
  input: GetEffectiveSettingInput,
): Promise<GetEffectiveSettingQueryResponse> => {
  return graphQLApi<GetEffectiveSettingQueryResponse, GetEffectiveSettingVariables>({
    query: getEffectiveSettingQuery,
    queryVariables: {
      input,
    },
  });
};
